import React, { useState } from 'react';

const RegisterPage = ({ onRegisterSuccess, onNavigateToLogin }) => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);

    const validateForm = () => {
        if (!name.trim()) {
            setError('Name is required');
            return false;
        }
        if (!email.trim()) {
            setError('Email is required');
            return false;
        }
        if (!email.includes('@')) {
            setError('Please enter a valid email address');
            return false;
        }
        if (password.length < 6) {
            setError('Password must be at least 6 characters long');
            return false;
        }
        if (password !== confirmPassword) {
            setError('Passwords do not match');
            return false;
        }
        return true;
    };

    const handleRegister = async (e) => {
        e.preventDefault();
        setError('');
        setMessage('');
        if (!validateForm()) {
            return;
        }
        setLoading(true);
        try {
            const response = await fetch('/api/add-user.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ name: name.trim(), email: email.trim(), password })
            });
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const result = await response.json();
            if (result.success) {
                setMessage('Registration successful! You can now sign in.');
                setName('');
                setEmail('');
                setPassword('');
                setConfirmPassword('');
                onRegisterSuccess();
            } else {
                setError(result.message || 'Registration failed. Please try again.');
            }
        } catch (err) {
            setError('Registration failed. Please check your network connection and try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <h2>Create Account</h2>
            {error && <div>{error}</div>}
            {message && <div>{message}</div>}
            <form onSubmit={handleRegister}>
                <div>
                    <label>Full Name</label>
                    <input
                        type="text"
                        placeholder="Enter your full name"
                        value={name}
                        onChange={e => setName(e.target.value)}
                        required
                        disabled={loading}
                    />
                </div>
                <div>
                    <label>Email</label>
                    <input
                        type="email"
                        placeholder="Enter your email"
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                        required
                        disabled={loading}
                    />
                </div>
                <div>
                    <label>Password</label>
                    <input
                        type={showPassword ? "text" : "password"}
                        placeholder="Create a password (min 6 characters)"
                        value={password}
                        onChange={e => setPassword(e.target.value)}
                        required
                        disabled={loading}
                    />
                    <button type="button" onClick={() => setShowPassword(v => !v)} disabled={loading}>
                        {showPassword ? 'Hide' : 'Show'}
                    </button>
                </div>
                <div>
                    <label>Confirm Password</label>
                    <input
                        type={showConfirmPassword ? "text" : "password"}
                        placeholder="Confirm your password"
                        value={confirmPassword}
                        onChange={e => setConfirmPassword(e.target.value)}
                        required
                        disabled={loading}
                    />
                    <button type="button" onClick={() => setShowConfirmPassword(v => !v)} disabled={loading}>
                        {showConfirmPassword ? 'Hide' : 'Show'}
                    </button>
                </div>
                <button type="submit" disabled={loading}>
                    {loading ? 'Creating Account...' : 'Create Account'}
                </button>
            </form>
            <div>
                <span>Already have an account?</span>
                <button type="button" onClick={onNavigateToLogin} disabled={loading}>
                    Back to Sign In
                </button>
            </div>
        </div>
    );
};

export default RegisterPage;
  